import { HttpClient } from './client/httpClient';
import backendHttpClient from './client/backendHttpClient';
import { EsmeModel, EsmeObject } from '../models/esmeModel';
import { EsmeResponse } from './responses/esmeResponse';
import { VersionableId } from '../types/versionableId';
import { ErrorHandler } from './error/errorHandler';
import apiErrorHandler from './error/apiErrorHandler';

class EsmeApi {
  constructor(private readonly httpClient: HttpClient,
              private readonly errorHandler: ErrorHandler) {}

  public fetchAllEsmeByCommitId(commitId: string): Promise<EsmeModel[]> {
    return this.httpClient.get<EsmeResponse[]>(`/commits/${commitId}/ESMEs`)
      .then(response => response.map(it => this.mapToEsmeModel(commitId, it)))
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch all ESMEs by commit id'));
  }

  public fetchEsmeConfigFile(esmeId: VersionableId): Promise<string> {
    return this.httpClient.get<string>(`/commits/${esmeId.commitId}/ESMEs/${esmeId.resourceName}/config-file`)
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch config file for ESME'));
  }

  public addEsme(schemaName: string, esme: EsmeObject): Promise<void> {
    return this.httpClient.post<void>(`/schemas/${schemaName}/ESMEs`, esme)
      .catch(error => this.errorHandler.handleError(error, 'Failed to add ESME'));
  }

  public updateEsme(schemaName: string, esmeName: string, esme: EsmeObject): Promise<void> {
    return this.httpClient.put<void>(`/schemas/${schemaName}/ESMEs/${esmeName}`, esme)
      .catch(error => this.errorHandler.handleError(error, 'Failed to update ESME'));
  }

  public deleteEsme(schemaName: string, esmeName: string): Promise<void> {
    return this.httpClient.delete<void>(`/schemas/${schemaName}/ESMEs/${esmeName}`)
      .catch(error => this.errorHandler.handleError(error, 'Failed to delete ESME'));
  }

  public generateEsmeConfigFilePreview(esme: EsmeObject): Promise<string> {
    return this.httpClient.post<string>('/config-files/esme/preview', esme)
      .catch(error => this.errorHandler.handleError(error, 'Failed to generate config file preview for ESME'));
  }

  private mapToEsmeModel(commitId: string, esmeResponse: EsmeResponse): EsmeModel {
    return {
      id: {
        commitId,
        resourceName: esmeResponse.esmeName,
      },
      object: {
        user: esmeResponse.user,
        moRoutes: esmeResponse.moRoutes,
        mtRoutes: esmeResponse.mtRoutes,
      },
    };
  }
}

export default new EsmeApi(backendHttpClient, apiErrorHandler);
